import { DeleteStages } from 'constants/deleteStages';

import { Box } from 'shared/mui/Box';
import { Dialog, DialogProps } from 'shared/mui/Dialogs';
import { DeleteStageDialogForm } from 'shared/mui/Dialogs/DeleteStageDialog/DeleteStageDialogForm';

type DeleteStageDialogProps = {
  title: string;
  details: React.ReactNode;
  children: React.ReactNode;
  stage: DeleteStages;
  deleteOneRecord: () => void;
} & DialogProps;

export const DeleteStageDialog: React.FC<DeleteStageDialogProps> = ({
  open,
  onClose,
  title,
  details,
  deleteOneRecord,
  children,
  stage,
}) => {
  return (
    <Dialog onClose={onClose} open={open} width="640px">
      <Box
        sx={{
          display: 'flex',
          top: '50%',
          flexDirection: 'column',
          padding: 0,
        }}
      >
        <DeleteStageDialogForm
          deleteOneRecord={deleteOneRecord}
          details={details}
          onClose={onClose}
          open={open}
          stage={stage}
          title={title}
        >
          {children}
        </DeleteStageDialogForm>
      </Box>
    </Dialog>
  );
};
